import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m8tfhuqt3u: FaireBrandEntity = {
  token: "b_m8tfhuqt3u",
  type: "brand",
  name: "Kickin it up Socks",
  avatarUrl:
    "https://cdn.faire.com/fastly/898777c23bf7e968fb7f762df50b654510df1962ce41dbe3a6839fb450631523.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8462132b346e48489fe31283920b872840dc55953feb4597daaa324254839ed4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/898777c23bf7e968fb7f762df50b654510df1962ce41dbe3a6839fb450631523.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8462132b346e48489fe31283920b872840dc55953feb4597daaa324254839ed4.jpeg",
  location: "Merced, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    "Kickin it up Socks originally started with a love of tie dying and bringing a new trend of socks that match with every day wear. Once we started creating one of a kind pieces we saw the demand in the market for socks that could be paired with any brand of shoe and would still compliment it. We have now grown to design our socks in house in California and have them manufactured so we can meet our clients growing needs and have a product that is everlasting in color. Our goal is to have a product that is classic and can be paired with any outfit for any occasion. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:09.395Z",
    importedBy: "entity-db-cli",
  },
};
